export default {
  A: {
    'ABO-Incompatibility': {
      title: 'ABO Incompatibility',
      definition:
        'Blood incompatibility between the mother and baby that can result in destruction of babe’s red blood cells, which can lead to jaundice and anemia.',
      references: {
        jaundice: 'Jaundice',
        anemia: 'Anemia'
      }
    },
    Acetaminophen: {
      title: 'Acetaminophen (Tylenol, Tempra)',
      definition:
        'A medication given as a pain reliever or for fever, but not for inflammation.'
    },
    Acidosis: {
      title: 'Acidosis',
      definition:
        'A condition caused by the buildup of acids in the body. These acid products may result from breathing problems **(respiratory acidosis)** or poor function of other body systems **(metabolic acidosis)**'
    },
    'Adjusted-Age': {
      title: 'Adjusted Age',
      definition: 'See corrected age.',
      references: {
        'See corrected age': 'Corrected-Age'
      }
    },
    'Airway-Malformation': {
      title: 'Airway Malformation',
      definition:
        'Is congenital (present from birth) defect that includes a cystic mass of abnormal lung tissue. A cystic mass is a noncancerous tumor that is filled with fluid or other material.'
    },
    'Amniotic-Fluid': {
      title: 'Amniotic Fluid',
      definition: 'The fluid that surrounds the baby in the mother’s uterus.'
    },
    Analgesic: {
      title: 'Analgesic',
      definition: 'A drug that reduces pain.'
    },
    Anemia: {
      title: 'Anemia',
      definition:
        'One of the more common blood disorders, anemia occurs when the level of healthy red blood cells in the body becomes too low.'
    },
    Antibody: {
      title: 'Antibody',
      definition:
        'A protein found in the blood, produced in response to foreign substances such as bacteria or viruses invading the body. Antibodies protect the body from disease by binding to these organisms and destroying them.'
    },
    'Apgar-Score': {
      title: 'Apgar Score',
      definition:
        'A scoring system, measured on a scale of 1 to 10, that helps estimate a baby’s general condition at birth. The test measures a baby’s heart rate, breathing, muscle tone, reflex response, and color at 1 minute, 5 minutes, and 10 minutes of life.'
    },
    Apnea: {
      title: 'Apnea',
      definition:
        'A pause in breathing that lasts longer than 20 seconds. Can be common in premature babies.'
    },
    'Apnea-of-Prematurity': {
      title: 'Apnea of Prematurity',
      definition:
        'Occurs in babies who are born prematurely (before 34 weeks of gestation). Because the brain or respiratory system may be immature or underdeveloped, the baby may not be able to regulate his or her own breathing.'
    },
    Artery: {
      title: 'Artery',
      definition: 'Blood vessel that carries oxygen to all parts of the body.'
    },
    Asphyxia: {
      title: 'Asphyxia',
      definition: 'Lack of oxygen.'
    },
    Aspiration: {
      title: 'Aspiration',
      definition:
        'Inhaling a foreign object into the windpipe or lungs, such as food, liquid, medicine, or meconium.'
    },
    'Attending-Physician': {
      title: 'Attending Physician/Nurse Practitioner',
      definition:
        'The member of the medical team who has been selected by or assigned to your baby and who has assumed primary responsibility for the treatment and care of the patient. Your attending may change during the duration of your baby’s stay.'
    },
    Audiologist: {
      title: 'Audiologist',
      definition:
        'A medical professional who treats patients with hearing, balance, and related ear problems.'
    },
    'Autonomic-Cues': {
      title: 'Autonomic Cues',
      definition:
        '“Involuntary responses that a baby cannot usually control” (ie. hiccups, spitting up, changes in heart rate or breathing rate, changes in skin colour).'
    },
    'Axillary-Temperature': {
      title: 'Axillary Temperature',
      definition: 'Checking a temperature under the armpit.'
    }
  },
  B: {
    BFI: {
      title: 'Baby Friendly Initiative (BFI)',
      definition:
        'A world wide effort to create routine practices and care that promotes, protects and supports breastfeeding. This is done through policy development, education and communication with families.'
    },
    Bacteria: {
      title: 'Bacteria',
      definition:
        'Tiny micro-organisms that thrive in many different places. Bacterial infections can be treated by antibiotics.'
    },
    Bagging: {
      title: 'Bagging',
      definition:
        'Pumping air or oxygen into a baby’s lungs by squeezing a bag or air into a mask placed over the baby’s mouth and nose, or through an endotracheal tube.'
    },
    'Barrier-Cream': {
      title: 'Barrier Cream',
      definition:
        'A cream applied to a baby’s bum after the diaper area is cleaned. Prevents moisture and rashes from developing.'
    },
    Betamethasone: {
      title: 'Betamethasone',
      definition:
        'A steroid medication, specifically a corticosteroid, given to a mother that is threatening preterm labour before the baby is born to help the baby’s lung mature more quickly. It also helps the intestines, kidneys, and other systems to mature.'
    },
    Bilirubin: {
      title: 'Bilirubin',
      definition:
        'Bilirubin is produced when red blood cells are broken down, which is a normal body process. A baby’s liver will breakdown bilirubin and get rid of it through the intestine. When bilirubin builds up faster than a baby’s liver can break it down, a baby will develop jaundice, which may make the skin and eyes look yellow or orange in colour.',
      references: {
        jaundice: 'Jaundice'
      }
    },
    'Bili-Lights': {
      title: 'Bili Lights',
      definition: 'Blue lights used to treat jaundice.',
      references: {
        jaundice: 'Jaundice'
      }
    },
    'Birth-Defect': {
      title: 'Birth Defect',
      definition:
        'Abnormality of structure, function, or body metabolism present at birth, may result in physical or mental disability, or may be fatal in some cases.'
    },
    'Blood-Cultures': {
      title: 'Blood Cultures',
      definition: 'See cultures.',
      references: {
        'See cultures': 'Culture'
      }
    },
    'Blood-Gases': {
      title: 'Blood Gases',
      definition: 'Levels of oxygen and carbon dioxide in the blood.'
    },
    Bradycardia: {
      title: 'Bradycardia',
      definition:
        'A slowing of the baby’s heart rate, define as less than 100 beats per minute.'
    },
    'Breast-Pump': {
      title: 'Breast Pump',
      definition:
        'A machine used to collect breast milk. A hospital-grade breast pump is often more powerful than those for home use, and are available for all moms to use while their baby is in the NICU.'
    },
    BPD: {
      title: 'Bronchopulmonary Dysplasia (BPD)',
      definition:
        'A chronic lung condition that is most common among children who were born prematurely, with low birth weights, and who received prolonged mechanical ventilation. It is characterized by rapid breathing, shortness of breath, or gasping to get more oxygen. Babies with BPD may require extended oxygen support.',
      references: {
        'mechanical ventilation': 'Mechanical-Ventilation'
      }
    }
  },
  C: {
    Cannula: {
      title: 'Cannula',
      definition:
        'A slender, clear, tube that sits below the nose and can be used to deliver oxygen.'
    },
    'Cardiopulmonary-Monitor': {
      title: 'Cardiopulmonary Monitor',
      definition:
        'Machine that tracks heart rate, oxygen saturation, and breathing rates.'
    },
    Cardiologist: {
      title: 'Cardiologist',
      definition: 'A doctor who specializes in taking care of heart problems.'
    },
    Catheter: {
      title: 'Catheter',
      definition:
        'A hollow, flexible tube for insertion into a body cavity, duct, or vessel to allow the passage of fluids (ie. IV fluids into vein), or drain a passageway or body cavity (ie. drain urine from the bladder).',
      references: {
        'IV fluids': 'IV'
      }
    },
    'Central-Line': {
      title: 'Central Line (also known as Central Venous Line)',
      definition:
        'A narrow tube that is inserted into a blood vessel and passed into a larger blood vessel in the chest. It may be used to provide a baby with IV fluids, medicine, or used to draw blood.',
      references: {
        'IV fluids': 'IV'
      }
    },
    CP: {
      title: 'Cerebral Palsy (CP)',
      definition:
        'Appearing in the first few years of life, this diagnosis means the child will have abnormal muscle tone (too tight or too loose) and might also have problems moving parts of their body. The extent of the problem may not be fully known until about age 2 years.'
    },
    Cerebellum: {
      title: 'Cerebellum',
      definition:
        'The part of the brain located at the back of the head. It is involved in the control of voluntary and involuntary movement and balance.'
    },
    Chronic: {
      title: 'Chronic',
      definition: 'A long-standing or long-term health condition.'
    },
    'Chronological-Age': {
      title: 'Chronological Age',
      definition: 'A baby’s actual age in days, weeks, months or even years'
    },
    'Circadian-Rhythm': {
      title: 'Circadian Rhythm',
      definition:
        'The circadian rhythm is a cycle that tells our bodies when to sleep, rise, eat--regulating many physiological processes. This internal body clock is affected by environmental cues, like sunlight and temperature.'
    },
    'Cluster-Care': {
      title: 'Cluster Care',
      definition:
        'Grouping baby’s care together to limit disruption of babies sleep or rest time. (i.e. diaper change with temperature check)'
    },
    Colostrum: {
      title: 'Colostrum',
      definition:
        'Thick nutrient filled drops from your breast after delivery. Replaced by milk after a few days.'
    },
    CBC: {
      title: 'Complete Blood Count (CBC)',
      definition:
        'Blood test that looks at different components of a baby’s blood, including the number and type of white blood cells (infection-fighting cells), the concentration of hemoglobin (carries oxygen), hematocrit (the percentage of blood volume consisting of red blood cells), and the number of platelets (blood-clotting cells).',
      references: {
        hemoblobin: 'Hemoglobin',
        hematocrit: 'Hematocrit'
      }
    },
    CT: {
      title: 'Computed Tomography (CT or CAT Scan)',
      definition:
        'Imaging technique that produces precise pictures of tissue using a narrow beam of radiation and computer processing of a series of images.'
    },
    Constipation: {
      title: 'Constipation',
      definition:
        'A condition of the bowels in which the feces are dry and hardened and evacuation is difficult and infrequent.'
    },
    CPAP: {
      title: 'CPAP (Continuous Positive Airway Pressure)',
      definition:
        "Air is delivered to a baby's lungs either through small tubes in a baby's nose, through a mask over a baby’s nose, or an ET tube. CPAP provides a continuous flow of air, sometimes with extra oxygen, to keep the tiny air passages in the lungs open, helping the baby breathe."
    },
    'Corrected-Age': {
      title: 'Corrected age',
      definition:
        'Used most to describe a child’s age up to 3 years of age when they were born preterm. “Corrected age” or “adjusted age” is calculated by subtracting the number of weeks born before 40 weeks of gestation from the chronological age. *(ie. if your baby was born at 30 weeks gestation, 10 weeks early, when your baby is 18 weeks old, their adjusted age would be 8 weeks)*',
      references: {
        'ET tube': 'ET-Tube'
      }
    },
    'Cradle-Cap': {
      title: 'Cradle Cap (Seborrhea)',
      definition:
        'Flakey yellow dry skin patches that can appear on your baby’s scalp around one to two months of age. Make sure to wash soap out well when bathing your baby. Apply a baby oil or olive oil and comb lightly to remove flakes. Do not pick at cradle cap.'
    },
    Cue: {
      title: 'Cue',
      definition:
        'How your baby communicates, a signal from your baby (ie. facial expression, body movement, or physiologic change) that can tell you how your baby is feeling or what your baby needs.'
    },
    Culture: {
      title: 'Culture',
      definition:
        'A laboratory test that detects infections in the body by placing samples in special nutrients that allow bacteria to grow. Common cultures done in the NICU: blood cultures and urine cultures.'
    },
    Cyanosis: {
      title: 'Cyanosis',
      definition:
        'A blue or gray discoloration of the skin caused by not enough oxygen.'
    },
    CMV: {
      title: 'Cytomegalovirus (CMV)',
      definition:
        'A viral infection that, when contracted by a pregnant woman, can result in severe newborn illness, and sometimes lead to chronic disabilities such as mental retardation, or vision and hearing loss. CMV also can be acquired after birth and can lead to hearing loss.'
    }
  },
  D: {
    Dehydration: {
      title: 'Dehydration',
      definition:
        'Excessive loss of water from the body. When a person loses more water than they take in.'
    },
    'Developmental-Delays': {
      title: 'Developmental Delays',
      definition:
        'The failure to meet certain milestones, such as rolling, sitting, walking, and talking at the average age. Up until 2 years of age, use a baby’s corrected age when looking at milestones and possible developmental delays.',
      references: {
        'corrected age': 'Corrected-Age'
      }
    },
    'Developmental-Milestones': {
      title: 'Developmental Milestones',
      definition:
        'Certain progress that your child makes in their development such as rolling, sitting, walking, and talking at the average age.'
    },
    'Diaphragmatic-Hernia': {
      title: 'Diaphragmatic Hernia',
      definition:
        'Birth defect involving an opening in the diaphragm, the large muscle that separates the chest and abdomen. Abdominal organs, such as the stomach, liver, and intestines may move through the opening into the chest, where they may prevent proper lung development.'
    },
    Dietician: {
      title: 'Dietician',
      definition:
        'A health care provider with at least 4 years of schooling. They assess nutritional needs, develop eating programs, monitor growth progress, and give parents advice on feeding their baby.'
    },
    Diptheria: {
      title: 'Diptheria',
      definition:
        'Diphtheria is caused by the bacteria Corynebacterium diphtheriae. This germ produces a toxin that can harm or destroy human body tissues and organs.'
    },
    'Due-Date': {
      title: 'Due Date (EDC)',
      definition:
        'The estimated time your baby was due to be born at full term or 40 weeks gestation.'
    },
    DBM: {
      title: 'Donor Breast Milk (DBM)',
      definition:
        "Defined as breast milk expressed by a mother that is then processed by a donor milk bank for use by a recipient that is not the mother's own baby."
    }
  },
  E: {
    Echo: {
      title: 'Echo (Echocardiogram)',
      definition:
        'The use of ultrasound to view the structure and function of the heart.'
    },
    ECG: {
      title: 'ECG/EKG (Electrocardiogram)',
      definition:
        'Measurement of electrical activity of the heart from a number of specific viewpoints. This activity is detected through adhesive electrodes placed on the chest, arms, and legs.',
      references: {
        electrodes: 'Electrodes'
      }
    },
    EDC: {
      title: 'EDC (estimated date of confinement)',
      definition: 'See due date',
      references: {
        'See due date': 'Due-Date'
      }
    },
    Electrodes: {
      title: 'Electrodes',
      definition:
        'Often referred to as “leads” - a conductor used to connect a monitoring circuit to a baby’s body, often looks like a small sticky pad attached to a wire. Commonly used to monitor heart or brain activity. All babies requiring cardiopulmonary monitoring will have 3 leads on their chest area at all times.'
    },
    EEG: {
      title: 'Electroencephalogram (EEG)',
      definition:
        'A measurement using electrodes placed on the scalp to record the electrical activity of the brain.'
    },
    'ET-Tube': {
      title: 'Endotracheal Tube (ET Tube)',
      definition:
        ' A tube that is placed down the trachea (windpipe) and delivers warm humidified air, sometimes containing extra oxygen, into the lungs.'
    },
    'Exchange-Transfusion': {
      title: 'Exchange Transfusion',
      definition:
        "Special type of blood transfusion in which some of the baby's blood is removed and replaced with blood from a donor. This type of transfusion can be used to treat severe jaundice."
    },
    ECMO: {
      title: 'Extracorporeal Membrane Oxygenation (ECMO)',
      definition:
        'In babies, this machine is used to allow the lungs to rest and recover from disease or medical conditions. ECMO is similar to the heart-lung bypass that is used in the operating room for heart surgery, but, in newborns, it is used for longer periods of time. It is also called extracorporeal life support (ECLS).'
    },
    Extrauterine: {
      title: 'Extrauterine',
      definition: 'Something that exists, forms or occurs outside of the body.'
    },
    ELBW: {
      title: 'Extremely Low Birth Weight (ELBW)',
      definition:
        'Babies born with a birth weight of less than 1000g or 2 lbs 3 oz.'
    },
    'Extremely-Premature': {
      title: 'Extremely Premature',
      definition: 'Babies born between 23 and 27 weeks gestation.'
    }
  },
  F: {
    Family: {
      title: 'Family',
      definition:
        'People who care about one another, may not live together (loving care books)'
    },
    'Failure-to-Thrive': {
      title: 'Failure to Thrive',
      definition:
        'The failure to grow and gain weight as expected, which is measured by daily weight and weekly length/height measurement trends.'
    },
    Fellow: {
      title: 'Fellow',
      definition:
        'A physician who has completed medical school, internship, and a residency, and currently is undergoing very specialized (subspecialty) training in one particular field of study. Neonatology fellows are training to become specialists in newborn medicine.'
    },
    'Football-Hold': {
      title: 'Football Hold',
      definition:
        'While seated, cradle your baby like a football. With their hand in your head and their body across the side of your body.'
    },
    Formula: {
      title: 'Formula',
      definition:
        'Is a manufactured alternative to breastmilk. They are prepared with properly boiled water and contain proper amounts of water, carbohydrates, protein, fats, vitamins, and minerals. There are milk-based and soy-based formulas.'
    },
    Fontanel: {
      title: 'Fontanel',
      definition:
        'The “soft spots” between the parts of the baby’s skull that will later grow together.'
    },
    Foremilk: {
      title: 'Foremilk',
      definition:
        'The milk the baby receives at the beginning of breastfeeding, also known as a “thirst quencher” it is high lactose “milk sugar” and low in fat and calories. It is thin and watery.'
    },
    'Full-Term-Baby': {
      title: 'Full Term Baby',
      definition: '37 to 42 weeks gestation.'
    }
  },
  G: {
    GERD: {
      title: 'Gastroesophageal Reflux (GERD)',
      definition:
        'This occurs when gastric juice from the stomach backs up into the esophagus. Adults refer to this as “heartburn” although it has nothing to do with the heart.'
    },
    Gastroschisis: {
      title: 'Gastroschisis',
      definition:
        "A birth defect involving an opening in the abdominal wall, through which the abdominal organs bulge out. The defect is usually located near the umbilical cord. The hole can be small or large and sometimes other organs, such as the stomach and liver, can also be found outside of the baby's body."
    },
    'Gavage-Feeding': {
      title: 'Gavage Feeding',
      definition:
        "Also called a “tube feeding.” A method of feeding a baby before he has learned how to coordinate breathing and swallowing. A small flexible tube is placed into a baby's nose or mouth and passed down into the stomach."
    },
    Gestation: {
      title: 'Gestation',
      definition:
        'Period of time between last menstrual period and birth. In humans, 40 weeks is the average gestation for a full-term singleton. Commonly called pregnancy.'
    },
    'Glycerin-Suppository': {
      title: 'Glycerin suppository',
      definition:
        'Glycerin suppository is used as a laxative. It works by causing the intestines to hold more water, which softens the stool. Glycerin suppository is used to treat occasional constipation.'
    },
    Glucometer: {
      title: 'Glucometer (glucose meter)',
      definition:
        'A hand held device used to measure the approximate concentration of glucose in the blood.'
    },
    Gram: {
      title: 'Gram',
      definition:
        'A metric unit of weight equal to one thousandth of a kilogram. One gram weighs the same as one plain M&M candy or one small paper clip. There are 30 grams in an ounce.'
    },
    'Group-B-Streptococcus': {
      title: 'Group B Streptococcus',
      definition:
        'Bacterial infection that a baby can contract as he passes through the birth canal, sometimes resulting in further illness. Many cases can be prevented by screening and/or treating infected women with antibiotics during labor and delivery.'
    }
  },
  H: {
    'Health-Care-Provider': {
      title: 'Health Care Provider',
      definition:
        'A person that you see in the hospital that informs you about clinical care. This could include, but it not limited to: a nurse, nurse practitioner, lactation consultant, family doctor, neonatologist.'
    },
    HIB: {
      title: 'Haemophilus influenza type B (HIB)',
      definition:
        'A bacteria responsible for severe pneumonia, meningitis and other invasive diseases. It appears almost exclusively in children 5 years old or younger. It is transmitted through the respiratory tract from infected to vulnerable individuals.'
    },
    Hematocrit: {
      title: 'Hematocrit',
      definition:
        'The percentage of blood volume consisting of red blood cells. Used as a measure of anemia.'
    },
    Hemoglobin: {
      title: 'Hemoglobin',
      definition:
        'The component of red blood cells that carries oxygen. Used as a measure of anemia.'
    },
    'Hepatitis-B': {
      title: 'Hepatitis B',
      definition:
        'A viral infection that attacks the liver and can cause both severe and chronic or long-term disease. It is transmitted through contact with the blood or other body fluids of an infected person.'
    },
    'Hepatitis-B-Vaccine': {
      title: 'Hepatitis B Vaccine',
      definition: 'A vaccine given for the prevention of Hepatitis B.'
    },
    'Herpes-Simplex': {
      title: 'Herpes Simplex',
      definition:
        'A virus that can be transmitted sexually, sometimes causing genital sores in infected adults. The virus can occupy the mouth, the genitals, or birth canal. It appears on the lips, as “cold sores.” A baby may become infected passing through an infected birth canal, sometimes resulting in severe newborn illness or future medical problems.'
    },
    Hernia: {
      title: 'Hernia',
      definition:
        'The protrusion of an organ or structure through muscles that usually contain them.'
    },
    'High-Frequency-Ventilation': {
      title: 'High-Frequency Ventilation',
      definition: 'See Oscillator.',
      references: {
        'See Oscillator': 'Oscillator'
      }
    },
    'Hind-Milk': {
      title: 'Hind milk',
      definition:
        'The high-fat, high-calorie milk that your baby gets toward the end of a feeding. It is often thick and creamy.'
    },
    HPV: {
      title: 'Human Papillomavirus (HPV)',
      definition:
        'Is a collection of over 150 related viruses. It can be transmitted through intimate skin-to-skin contact - by having vaginal, anal, or oral sex with someone who has the virus. HPV can be passed to the baby in the vaginal canal.'
    },
    'HPV-Vaccine': {
      title: 'Human Papillomavirus (HPV) vaccine',
      definition: 'A vaccine for HPV.'
    },
    Hydrocephalus: {
      title: 'Hydrocephalus',
      definition:
        'A condition where too much fluid collects in the ventricles, exerting increased pressure on the brain and causing the baby’s head to expand abnormally.'
    },
    Hyperbilirubinemia: {
      title: 'Hyperbilirubinemia',
      definition:
        "A condition where there is too much bilirubin in the blood. When red blood cells break down, a substance called bilirubin is formed. Babies are not easily able to get rid of the bilirubin and it can build up in the blood and other tissues and fluids of the baby's body."
    },
    Hyperglycemia: {
      title: 'Hyperglycemia',
      definition: 'High blood glucose levels.'
    },
    Hypoglycemia: {
      title: 'Hypoglycemia',
      definition: 'Low blood glucose levels.'
    }
  },
  I: {
    Ibuprofen: {
      title: 'Ibuprofen (Advil)',
      definition:
        'A drug used to treat fever, swelling, pain, and redness by preventing the body from making a substance that causes inflammation. It is a type of nonsteroidal anti-inflammatory drug (NSAID). Also called Advil.'
    },
    Immunization: {
      title: 'Immunization',
      definition:
        'The process when person becomes protected against a disease. Can also be called vaccination or vaccine.'
    },
    Incubator: {
      title: 'Incubator/Isolette',
      definition:
        'A heat-controlled crib used to maintain a baby’s body temperature in the normal range.'
    },
    Inflammation: {
      title: 'Inflammation',
      definition:
        'Pain, redness, and swelling, possibly caused by infection or injury.'
    },
    'Influenza-Vaccine': {
      title: 'Influenza (flu) vaccine',
      definition:
        'A highly contagious viral infection with sudden onset of fever, severe aches and pains, and inflammation of the mucous membrane. There are different strains. The vaccine can provide protection against different strains of the virus.'
    },
    Intrauterine: {
      title: 'Intrauterine',
      definition: 'Referring to inside the uterus.'
    },
    IUGR: {
      title: 'Intrauterine Growth Restriction (IUGR)',
      definition:
        'Inadequate growth of the fetus so that it is smaller than expected for gestational age. This can happen at any time during pregnancy.'
    },
    IV: {
      title: 'Intravenous (IV)',
      definition:
        'A small tube inserted into a vein in the hand, foot, arm, leg, or scalp. An IV delivers medicine and/or fluids into the blood.'
    },
    IVH: {
      title: 'Intraventricular Hemorrhage (IVH)',
      definition:
        'Condition in which immature and fragile blood vessels within the brain bleed into the hollow chambers (ventricles) normally reserved for cerebrospinal fluid. Sometimes this bleeding also spreads into the tissue surrounding the ventricles. An IVH is assigned a grade to give an estimate of how serious it is.'
    },
    Intubation: {
      title: 'Intubation',
      definition:
        'The procedure of inserting a tube through the mouth or nose, down the throat, and into the trachea or windpipe of a patient who may have difficulty breathing or might be at risk of stopping breathing because of illness, surgery, or other medical problem.'
    }
  },
  J: {
    Jaundice: {
      title: 'Jaundice',
      definition:
        "Yellow discoloration of skin and, sometimes, whites of the eyes that results from excess of a body chemical called bilirubin in the body's system. If it is significant, jaundice might require use of special lights (phototherapy) until the baby is more mature. Severe jaundice is treated with exchange transfusion. Also known as hyperbilirubinemia."
    }
  },
  K: {
    'Kangaroo-Care': {
      title: 'Kangaroo Care',
      definition:
        "Holding a baby against one's naked chest, so there is skin-to-skin contact. The caregiver can wear a tube top to enclose the baby."
    }
  },
  L: {
    Lactation: {
      title: 'Lactation',
      definition: 'The secretion of milk in the breast.'
    },
    'Lactation-Consultant': {
      title: 'Lactation Consultant',
      definition:
        'A healthcare provider who can assist with breastfeeding and lactation help.'
    },
    Lactogenesis: {
      title: 'Lactogenesis',
      definition:
        'The onset of milk secretion and includes all of the changes in the mammary tissue needed to go from the undifferentiated mammary gland in early pregnancy to full lactation sometime after parturition.'
    },
    Lanugo: {
      title: 'Lanugo',
      definition:
        'Fine, downy hair that covers the fetus until shortly before or after birth.'
    },
    Latch: {
      title: 'Latch',
      definition:
        'When a baby attaches their mouth to the nipple and begins to suck.'
    },
    'Lead-Wires': {
      title: 'Lead Wires',
      definition:
        'The wires that go from a monitor to its electrodes (sticky patches on the chest).'
    },
    Lesion: {
      title: 'Lesion',
      definition:
        'A patch of abnormal skin, or the part of an injury or infection that is abnormal and causes an illness.'
    },
    Ligation: {
      title: 'Ligation',
      definition:
        'The act of binding or of applying a tie, wire, or bandage around a limb or blood vessel to restrict blood flow. It is used to treat patent ductus arteriosus (PDA) among other uses.'
    },
    Lipids: {
      title: 'Lipids',
      definition:
        'An emulsion of fats administered through an IV or central line. Often used as nourishment for babies who are not able to get enough or any calories through oral feedings. Intralipids are commonly used in the NICU and consist of an emulsion of soy bean oil, egg phospholipids and glycerin. (See SMOF lipids)',
      references: {
        'See SMOF lipids': 'SMOF-Lipids'
      }
    },
    LBW: {
      title: 'Low Birth Weight (LBW)',
      definition:
        'Low birth weight babies are born weighing less than 2,500 g or 5lbs. 8oz. at birth.'
    },
    'Lumbar Puncture': {
      title: 'Lumbar Puncture',
      definition:
        'A diagnostic procedure that is done to collect a sample of spinal fluid for analysis, or, on rare occasions, to relieve increased pressure in the spinal fluid. It is also known as a spinal tap.'
    }
  },
  M: {
    MRI: {
      title: 'Magnetic Resonance Imaging (MRI)',
      definition:
        'Imaging technique that uses powerful magnets and computers to produce a detailed picture of internal tissues and organs.'
    },
    Maternal: {
      title: 'Maternal',
      definition: 'The role of mother.'
    },
    Measles: {
      title: 'Measles',
      definition:
        'A very contagious viral disease. Measles is transmitted via droplets from the nose, mouth or throat of an infected persons Symptoms, which usually appear 10–12 days after infection, include high fever, a runny nose, bloodshot eyes, and tiny white spots on the inside of the mouth. Several days later, a rash develops, starting on the face and upper neck and then spreading downwards.'
    },
    'Measles-Vaccine': {
      title: 'Measles Vaccine',
      definition: 'A vaccine for protection against Measles.'
    },
    'Mechanical-Ventilation': {
      title: 'Mechanical Ventilation',
      definition:
        'Using a ventilator to help a very sick baby breathe while his lungs recover.'
    },
    Meconium: {
      title: 'Meconium',
      definition:
        'Fecal material made by the fetus; usually passed in the first bowel movement after birth. Sometimes meconium is passed in the amniotic fluid before birth and inhaled in the amniotic fluid during the fetus’s normal breathing movement.'
    },
    MAS: {
      title: 'Meconium Aspiration Syndrome (MAS)',
      definition:
        "Problems caused by meconium (baby's first bowel movement) going into the lungs while the baby is still in the womb. This can be serious but, usually, the baby eventually recovers fully."
    },
    Meningitis: {
      title: 'Meningitis',
      definition:
        'An inflammation of the lining of the brain, usually from viral or bacterial infection.'
    },
    'Meningococcal-group-C-conjugate-vaccine': {
      title: 'Meningococcal group C conjugate vaccine',
      definition: ''
    },
    Microbiome: {
      title: 'Microbiome',
      definition:
        'The microorganisms in a particular environment (including the body or a part of the body).'
    },
    Microcephaly: {
      title: 'Microcephaly',
      definition:
        'A condition in which the circumference of the head is small because of abnormal brain growth. This condition might result in future cerebral palsy or learning problems.'
    },
    Micropreemie: {
      title: 'Micropreemie',
      definition: 'A newborn who weighs less than 800 g or 1lb. 12oz. at birth.'
    },
    Milestones: {
      title: 'Milestones',
      definition:
        'Skills most children can perform at certain ages. Examples include smiling, rolling, sitting, scooting, crawling, standing, walking, and talking.'
    },
    Monitor: {
      title: 'Monitor',
      definition:
        'A machine that records information such as heartbeat, body temperature, respiration rate, and blood pressure.'
    },
    'Moro-Reflex': {
      title: 'Moro Reflex',
      definition:
        'A normal reflex of young babies; a sudden loud noise causes the child to stretch out the arms and flex (scrunch up) the legs.'
    },
    Mumps: {
      title: 'Mumps',
      definition:
        'Mumps is an infection caused by a virus and spread human-to-human via direct contact or by airborne droplets. The virus affects the salivary glands. Symptoms are headache, malaise (discomfort) and fever, followed within a day by the swelling of the salivary glands. Mumps is generally a mild childhood disease, most often affecting children between five and nine years old. However, the mumps virus can infect adults as well and when it does, possible complications are more likely to be serious. Complications of mumps can include meningitis (in up to 15% of cases), orchitis and deafness. Very rarely, mumps can cause encephalitis and permanent neurological damage.'
    },
    'Mumps-Vaccine': {
      title: 'Mumps Vaccine',
      definition: 'A vaccine for the mumps.'
    }
  },
  N: {
    'Nasal-Cannula': {
      title: 'Nasal Cannula',
      definition:
        'The “oxygen tubes” that give extra oxygen by blowing moisturized oxygen, possibly mixed with air, into the nose.'
    },
    'Nasal-Prongs': {
      title: 'Nasal Prongs',
      definition:
        "Small plastic tubes that fit into or under a baby's nose to deliver oxygen."
    },
    'NG-Tube': {
      title: 'Nasogastric Tube (NG Tube)',
      definition:
        'A tube that is passed through the nose and down through the throat and esophagus and into the stomach.'
    },
    NEC: {
      title: 'Necrotizing Entercolitis (NEC)',
      definition:
        "An infection that destroys part of the baby's intestines. Drugs and/or surgery may be required."
    },
    'Neonatal-Nurse': {
      title: 'Neonatal Nurse',
      definition:
        'Neonatal nurses work with newborn infants born prematurely or who have birth defects, infection, cardiac malformations, and or surgical problems. Neonatal nursing typically includes care of infants who experience problems shortly after birth. In some cases this includes care for infants who experience long-term problems related to their prematurity or illness after birth.'
    },
    NNP: {
      title: 'Neonatal Nurse Practitioner (NNP)',
      definition:
        'An advanced practice nurse with specialized training and expertise in neonatal care, NNPs are licensed to assess, diagnose, manage, and treat critically ill and convalescing neonates. In addition, NNPs prescribe medicine, write orders, interpret results, perform emergency and daily procedures, and attend high-risk deliveries.'
    },
    Neurodevelopment: {
      title: 'Neurodevelopment',
      definition:
        "Refers to the brain's development of neurological pathways. They influence performance or functioning (e.g., intellectual functioning, reading ability, social skills, memory, attention or focus skills)."
    },
    Neurologist: {
      title: 'Neurologist',
      definition:
        'Physician with at least 3 years of post-medical school training specialized in dealing with the diseases and care of the brain and nerves.'
    },
    'Nitric-Oxide': {
      title: 'Nitric Oxide',
      definition:
        'A gas naturally produced by the body that can also be given as a medication that is breathed in and helps expand blood vessels. It is sometimes used to treat babies with persistent pulmonary hypertension of the newborn.'
    },
    Noninvasive: {
      title: 'Noninvasive',
      definition:
        'Something that does not enter the body through the skin or an opening (mouth, nose, anus, etc).'
    },
    NNS: {
      title: 'Non Nutritive Sucking (NNS)',
      definition:
        'A nursing intervention in which the baby sucks to self-calm, regulate. NNS is not associated with feedings.'
    }
  },
  O: {
    OT: {
      title: 'Occupational Therapist (OT)',
      definition:
        'A health care professional with 4 to six years of training that helps with a baby’s sensory system and their ability to organize and regulate the stimuli in the world around them.'
    },
    Oscillator: {
      title: 'Oscillator',
      definition:
        'Special form of mechanical ventilation, designed to help reduce complications to the infant’s delicate lungs. It provides rapid respiratory rates.'
    },
    Ophthalmologist: {
      title: 'Ophthalmologist',
      definition:
        'Physician (MD) specializing in diagnosis and treatment of eye diseases and disorders: refractive, medical, and surgical problems.'
    },
    'Orogastric-Tube': {
      title: 'Orogastric Tube',
      definition:
        'A flexible tube inserted through the mouth, down the throat and esophagus, and into the stomach.'
    },
    Ostomy: {
      title: 'Ostomy',
      definition:
        'A surgical procedure creating an opening in the body for the discharge of body wastes.'
    },
    Oximeter: {
      title: 'Oximeter (Pulse Oximeter)',
      definition:
        'A device worn on the hand or foot of neonates that painlessly measures levels of oxygen in the blood.'
    },
    Oxytocin: {
      title: 'Oxytocin',
      definition:
        'A hormone released by the pituitary gland that causes increased contraction of the uterus during labor and stimulates milk production. It is often called the love hormone.'
    },
    'Oxygen-Therapy': {
      title: 'Oxygen Therapy',
      definition:
        'Giving extra oxygen to the tissues of the body through the lungs in a number of ways, including through a ventilator (respirator), mask, nasal cannula, or plastic oxygen hood or tent. The amount of oxygen given may be measured as a percentage, and in number of liters, or milliliters, of flow per minute.'
    }
  },
  P: {
    PDA: {
      title: 'Patent Ductus Arteriosus (PDA)',
      definition:
        'A heart condition caused by the failure of a small blood vessel (the ductus arteriosus) to close. Usually, this normal opening between the aorta and the pulmonary artery closes just after birth. When it does not, the baby may be treated with medicine or surgery to fix the condition, to prevent too much blood from “flooding” the lungs.'
    },
    Pediatrician: {
      title: 'Pediatrician',
      definition:
        'Physician with at least 3 post-medical school years of training in the care and treatment of children.'
    },
    Pertussis: {
      title: 'Pertussis (whooping cough)',
      definition:
        'Is a highly contagious disease of the respiratory tract caused by Bordetella pertussis, a bacteria that lives in the mouth, nose, and throat. Children who contract pertussis can have coughing spells that last 4 to 8 weeks. The disease is most dangerous in infants and spreads easily from person to person, mainly through droplets from coughing or sneezing. The first symptoms appear 7–10 days after infection, and include mild fever, runny nose, and coughing (World Health Organization).'
    },
    'Pertussis-Vaccine': {
      title: 'Pertussis Vaccine',
      definition: 'A vaccine given for pertussis.'
    },
    PICC: {
      title: 'Percutaneous Line/Percutaneous Central Catheter (PICC)',
      definition:
        'A long catheter placed into a surface vein, with the catheter tip extending farther into the body into a large central vein. A PICC does not have to be replaced as often as a regular IV line.'
    },
    PFU: {
      title: 'Perinatal Follow Up (PFU)',
      definition:
        'Also known as the neonatal follow up program or high risk developmental clinic. It is dedicated to the care and monitoring of babies who were born very premature, very low birth weight or who experienced a known or suspected brain injury at birth. It includes the evaluation of long term developmental outcomes for these children.'
    },
    Perineum: {
      title: 'Perineum',
      definition: 'The area between the anus and vulva.'
    },
    'Peri-Bottle': {
      title: 'Peri Bottle',
      definition:
        'A bottle that is filled with saline water, with a squirt top. Used to clean the perineum area.'
    },
    'Periventricular-Leukomalacia': {
      title: 'Periventricular Leukomalacia',
      definition:
        'Changes, usually small cysts in brain tissue around the ventricles or fluid spaces of the brain. This cystic change is linked with an increased risk of future 114 problems with learning, vision, or movement.'
    },
    PPHN: {
      title: 'Persistent Pulmonary Hypertension of the Newborn (PPHN)',
      definition:
        'In PPHN, it is difficult for blood to get into the lungs and pick up more oxygen that can go to the rest of the body. The cause usually is unknown, and treatments are based on the individual situation. Persistent pulmonary hypertension (PPHN) is also known as Persistent Fetal Circulation (PFC).'
    },
    'Petroleum-Jelly': {
      title: 'Petroleum Jelly',
      definition:
        'Topical ointment used for healing and protecting the skin from moisture.'
    },
    Pharmacy: {
      title: 'Pharmacy',
      definition: 'Where medications are drawn up and distributed.'
    },
    Pharmacist: {
      title: 'Pharmacist',
      definition:
        'A health care provider that draws up medications in a pharmacy.'
    },
    Phototherapy: {
      title: 'Phototherapy',
      definition:
        'Treatment for jaundice in a newborn. The newborn is placed under (or on top of) special lights to help the body break down the extra bilirubin in the blood.'
    },
    PT: {
      title: 'Physical Therapist/Physiotherapist (PT)',
      definition:
        'A health care professional with 4 years or more of training who performs and teaches exercises and other physical activities to aid in rehabilitation and maximize physical muscle and movement development.'
    },
    Physiologic: {
      title: 'Physiologic',
      definition: 'The way in which the body, organs, tissues and cells works.'
    },
    'Pierre-Robin': {
      title: 'Pierre Robin',
      definition:
        'A congenital (present from birth) condition where the lower part of the jaw did not fully develop in the uterus.'
    },
    Placenta: {
      title: 'Placenta',
      definition:
        'An organ that connects the mother to baby in pregnancy, through the umbilical cord. The baby is nourished through the umbilical cord. The placenta is expelled or removed from the body soon after delivery.'
    },
    Plagiocephaly: {
      title: 'Plagiocephaly (flat head syndrome)',
      definition:
        'An asymmetrical flattening of one side of the skull. It is characterized by a flat spot on the back or one side of the head. This can be caused by remaining in a supine position for too long.'
    },
    Pleura: {
      title: 'Pleura',
      definition:
        'One of two membranes around the lungs. The visceral pleura covers the lungs, and the parietal pleura lines the inner chest wall. A small amount of pleural fluid acts as a lubricant between the two membranes'
    },
    'Pleural-Effusion': {
      title: 'Pleural Effusion',
      definition:
        'Excess fluid that is trapped between the lungs and chest wall. An accumulation of fluid can create difficulty breathing as it limits expansion of the lungs.  See tension pneumothorax.',
      references: {
        'See tension pneumothorax': 'Tension-Pneumothorax'
      }
    },
    'Pneumococcal-Infection': {
      title: 'Pneumococcal infection',
      definition:
        'Is an infection caused by the Streptococcus pneumoniae (S. pneumoniae) bacterium, also known as pneumococcus. Infection can result in pneumonia, infection of the blood, middle-ear infection or bacterial meningitis.'
    },
    'Pneumococcal-Vaccine': {
      title: 'Pneumococcal Vaccine',
      definition: 'A vaccine for pneumococcal infection.'
    },
    Pneumothorax: {
      title: 'Pneumothorax (collapsed lung)',
      definition:
        "Air in the space between the baby's lungs and chest wall (pleura). While small leaks usually cause no problems and require no treatment, larger leaks may cause serious complications, such as lung collapse. Treatment includes withdrawal of the air with a needle and syringe or a surgical procedure to place a tube to drain the trapped air and reinflate the lung. See pleural effusion.",
      references: {
        'See pleural effusion': 'Pleural-Effusion',
        pleura: 'Pleura'
      }
    },
    Polio: {
      title: 'Polio',
      definition:
        'A viral disease, which mainly affects young children. The virus is transmitted by person-to-person spread mainly through the fecal-oral route or by contaminated water or food. It can invade the nervous system and can cause paralysis. Symptoms of polio include fever, fatigue, headache, vomiting, stiffness in the neck, and pain in the limbs.'
    },
    'Polio-Vaccine': {
      title: 'Polio Vaccine',
      definition: 'A vaccine for polio.'
    },
    Postpartum: {
      title: 'Postpartum',
      definition: 'The period after you give birth.'
    },
    Prone: {
      title: 'Prone',
      definition: 'Placing baby on their tummy.'
    },
    'Pulse-Oximeter': {
      title: 'Pulse Oximeter',
      definition:
        'A small device that uses a light sensor to help determine blood oxygen levels.'
    },
    Pumping: {
      title: 'Pumping',
      definition:
        'Using a breast pump to pump or extract milk from lactating breasts. Breastmilk is then fed to the baby or stored for later use.'
    }
  },
  Q: {},
  R: {
    'Radiant-Warmer': {
      title: 'Radiant Warmer',
      definition:
        'A heater that works by sending out radiant energy, usually in the form of heat. It warms objects without needing to touch them. Radiant warmers are often used to maintain temperature of babies in the neonatal intensive care units.'
    },
    Radiologist: {
      title: 'Radiologist',
      definition:
        'A physician with 7 seven years of training who specializes in creating and interpreting pictures of areas inside the body.'
    },
    REM: {
      title: 'Rapid Eye Movement (REM)',
      definition:
        'Rapid Eye Movement is also known as active sleep. During rapid (REM) sleep, babies brains are very active. Your baby may make funny faces, stretch, suck, or move their eyes.  A lot of brain work is taken place, including dreaming. Babies enter REM sleep when they first fall asleep. During this sleep state babies are not in a deep sleep and may wake more easily. Adults also experience REM sleep but at different times and durations than babies.'
    },
    Resident: {
      title: 'Resident',
      definition:
        'A physician with 4 years of training in medical school who is in the process of completing the additional 3 years of training in a primary specialty (for example, pediatrics, ophthalmology, radiology, obstetrics/ gynecology) following medical school.'
    },
    Respirator: {
      title: 'Respirator',
      definition:
        'A machine that helps breathing by supplying and regulating a flow of air and oxygen that goes through a tube threaded through the nose or mouth, down the back of the throat, and into the trachea (windpipe). It is also called a ventilator.'
    },
    RDS: {
      title: 'Respiratory Distress Syndrome (RDS)',
      definition:
        'A condition that occurs in babies, more commonly in those born preterm, whose lungs are not fully developed, mainly due to a lack of a surfactant. Babies with RDS may have trouble keeping their lungs inflated and need support from a CPAP machine or a ventilator. They may also be given substitute for surfactant.'
    },
    RSV: {
      title: 'Respiratory Syncytial Virus (RSV)',
      definition:
        'A highly contagious virus that causes a mild, cold-like illness in adults. Full-term babies will get antibodies from their mothers during pregnancy that will help them fight RSV. For preterm babies who have lungs that are not fully developed and may not get enough of these antibodies, RSV can cause serious illness. RSV seasons runs from October to April. Ask your nurse about whether your baby is eligible to receive an RSV vaccine.',
      references: {
        antibodies: 'Antibody'
      }
    },
    'Respiratory-Therapists': {
      title: 'Respiratory Therapists',
      definition:
        'A health care professional with 3 to 5 years of training who assesses breathing and heart function, treats with oxygen therapy or ventilation, and gives medicines to help with breathing as prescribed by a physician or practitioner.'
    },
    Retina: {
      title: 'Retina',
      definition:
        'Lining at the rear of the eye that relays messages about what the eyes see to the brain.'
    },
    ROP: {
      title: 'Retinopathy of Prematurity (ROP)',
      definition:
        "A condition in which the blood vessels in the baby's eyes do not develop normally. This can reverse and normalize or progress to serious disease that can lead to hemorrhage, scarring, and/or retinal detachment that limit vision. ROP is treated with laser therapy."
    },
    'Rh-Disease': {
      title: 'Rh Disease',
      definition:
        'Blood incompatibility between the mother and fetus that causes destruction of fetal red blood cells.'
    },
    Rooting: {
      title: 'Rooting',
      definition:
        'When the baby opens mouth or bobs head around the breast to show that they are ready to breastfeed.'
    },
    Rotavirus: {
      title: 'Rotavirus',
      definition: 'A virus that causes diarrhea.'
    },
    'Rotavirus-Vaccine': {
      title: 'Rotavirus Vaccine',
      definition: 'A vaccine for the rotavirus.'
    },
    Rubella: {
      title: 'Rubella',
      definition: 'Is a type of measles that appears as a rash.'
    },
    'Rubella-Vaccine': {
      title: 'Rubella Vaccine',
      definition: 'A vaccine for rubella.'
    }
  },
  S: {
    Sepsis: {
      title: 'Sepsis',
      definition: ' A blood infection.'
    },
    'Shaken-Baby-Syndrome': {
      title: 'Shaken Baby Syndrome',
      definition:
        'The diagnosis of brain trauma. Caused by shaking a baby or putting them down or picking them up violently.'
    },
    'Sitz-Bath': {
      title: 'Sitz Bath',
      definition:
        'A small basin used to wash the buttocks and vagina. It is filled with water and placed on the toilet seat.'
    },
    'Skin-to-skin-contact': {
      title: 'Skin-to-skin contact',
      definition:
        'Holding a baby upright in its diaper only with its chest against your bare chest.'
    },
    SGA: {
      title: 'Small for Gestational Age (SGA)',
      definition:
        'Newborns whose birth weight is <10th percentile for their gestational age. If weight gain of the fetus is abnormal, this is called Intrauterine Growth Restriction (See IUGR).',
      references: {
        'See IUGR': 'IUGR'
      }
    },
    'Smart-Pump': {
      title: 'Smart Pump/Infusion Pump',
      definition:
        'Device that delivers measured amounts of fluids or medications into the bloodstream over a period of time.'
    },
    'SMOF-Lipids': {
      title: 'SMOF Lipids',
      definition:
        'An emulsion of fats administered through an IV or central line. Often used as nourishment for babies who are not able to get enough or any calories through oral feedings. SMOF lipids are made from four lipids, soybean oil (essential fatty acids), olive oil (monounsaturated fats), medium chain triglycerides and fish oil (omega three fatty acids).'
    },
    'Skin-Flora': {
      title: 'Skin Flora',
      definition:
        'Also known as our skin microbiota or skin microbiome, are the friendly microorganisms (microscopic organisms, such as bacteria) present on our skin… Learn more about microbiomes (link to microbiome info page)'
    },
    'Social-Worker': {
      title: 'Social Worker',
      definition:
        'A professional with 4 to 6 years of training who helps families cope with stress, crisis, and change. In the NICU setting, the social worker helps families access community resources such as support groups and assistance programs. Social workers help with planning the baby’s hospital discharge.'
    },
    'Spina-Bifida': {
      title: 'Spina Bifida',
      definition:
        'A birth defect involving the spinal cord, often resulting in varying degrees of paralysis, bladder, and bowel problems. Affected babies may require surgery during the newborn period to close the back and prevent further nerve damage and infection. Surgery cannot reverse nerve damage that already has occurred.'
    },
    'Step-down-Unit': {
      title: 'Step-down Unit',
      definition:
        'Nursing unit with patients who are not in need of intensive care but still require skilled nursing care.'
    },
    Stimuli: {
      title: 'Stimuli',
      definition:
        'Things that excite or move us to action, such as loud sounds and bright lights. Stimuli is the plural form of the word stimulus.'
    },
    Stooling: {
      title: 'Stooling',
      definition: 'The matter that comes out of the bowels during a movement.'
    },
    SIDS: {
      title: 'Sudden Infant Death Syndrome (SIDS)',
      definition:
        'A diagnosis given when a seemingly healthy infant dies without warning or preexisting condition. There are many recommendations to reduce your baby’s risk of SIDS. (link).'
    },
    SSI: {
      title: 'Supplemental Security Income (SSI)',
      definition:
        'A federal income program funded by general tax revenues. Parents of children who qualify, based on medical and financial criteria, receive monthly payments to assist with health care expenses.'
    },
    Surfactant: {
      title: 'Surfactant',
      definition:
        ' A protective substance that helps the small air sacs in the lungs to stay open.'
    },
    Syndrome: {
      title: 'Syndrome',
      definition:
        'A combination of signs and symptoms that, when present together, are associated with a specific medical condition.'
    },
    Swaddling: {
      title: 'Swaddling',
      definition:
        'Wrapping babies snugly in cloths or blankets so that movement of the limbs is restricted, providing the baby with a secure womb-like feeling.'
    }
  },
  T: {
    Tachycardia: {
      title: 'Tachycardia',
      definition: 'Rapid heart rate.'
    },
    Tachypnea: {
      title: 'Tachypnea',
      definition: 'Rapid breathing.'
    },
    Tetanus: {
      title: 'Tetanus',
      definition:
        'A bacterial disease that appears as rigidity and spasms of the voluntary muscles.'
    },
    'Tension-Pneumothorax': {
      title: 'Tension Pneumothorax',
      definition:
        'Damage to the chest wall that allows air to enter the pleural cavity but not escape.'
    },
    Thrush: {
      title: 'Thrush',
      definition: 'The presence of yeast in the mouth.'
    },
    Torticollis: {
      title: 'Torticollis (infant torticollis)',
      definition:
        'Contraction of the neck muscles causing the head to tilt or turn to one side. In infants this can happen because of positioning in the utero or after a difficult childbirth'
    },
    TPN: {
      title: 'Total Parenteral Nutrition (TPN)',
      definition:
        ' A technique in which nutrients are given to a person through an intravenous infusion. TPN often requires a PICC or CVL.',
      references: {
        PICC: 'PICC'
      }
    },
    Toxoplasmosis: {
      title: 'Toxoplasmosis',
      definition:
        'A parasitic infection that, when contracted by a pregnant woman, can result in serious newborn illness and chronic disabilities, such as intellectual disability, cerebral palsy, seizures, or vision and hearing loss.'
    },
    Transfusion: {
      title: 'Transfusion',
      definition:
        'The transfer of whole blood or blood products from one individual to another.'
    },
    'Transitional-Stool': {
      title: 'Transitional Stool',
      definition:
        'Loose yellow green stool past in the second to third day of life. Typically seen when mothers milk begins to come in.'
    },
    TTTS: {
      title: 'Twin-Twin Transfusion Syndrome (TTTS)',
      definition:
        'A disease of the placenta (or afterbirth) that affects identical twin pregnancies. The shared placenta contains abnormal blood vessels that can convey blood from one twin to another, resulting in a higher red blood cell count and, sometimes, better growth, in one twin than another.'
    }
  },
  U: {
    'Uric-Acid': {
      title: 'Uric Acid',
      definition:
        'Uric acid is produced from the breakdown of foods and the body’s cells. The kidneys filter most of the uric acid, it is then passed out of the body in urine.'
    },
    Ultrasound: {
      title: 'Ultrasound (Sonogram)',
      definition:
        'The use of ultrasonic waves for diagnostic or therapeutic purposes. In the NICU, ultrasound is used to obtain an image of an internal body structure.'
    },
    'Umbilical-Lines': {
      title: 'Umbilical Lines',
      definition:
        'A catheter inserted into one of the umbilical arteries (UAC) or umbilical vein (UVC). They are used to quickly deliver fluids or medication to babies.',
      references: {
        UAC: 'UAC',
        UVC: 'UVC'
      }
    },
    UAC: {
      title: 'Umbilical Arterial Catheter (UAC)',
      definition:
        'A line placed directly into the umbilical artery through the baby’s umbilical cord.'
    },
    UVC: {
      title: 'Umbilical Venous Catheter (UVC)',
      definition:
        'A line placed directly into the umbilical vein (a much larger vein than a peripheral vein) through the baby’s umbilical cord.'
    },
    'Urate-Crystals': {
      title: 'Urate Crystals (brick stain or brick dust)',
      definition:
        'Combination of calcium and urate, usually found in urine. This combination can form crystals that appear as a rust color in the baby’s diaper. This is normal for an infant in the first few days of life.'
    },
    Uterus: {
      title: 'Uterus',
      definition:
        'The hollow muscular organ in females where the fertilized egg normally becomes embedded. The uterus is where the fetus grows. It is also called the womb.'
    }
  },
  V: {
    Vaccine: {
      title: 'Vaccine/Vaccination',
      definition:
        'A vaccine is a biological preparation that improves immunity to or defense against a particular disease. A vaccine typically contains an agent that resembles a disease-causing microorganism, and is often made from weakened or killed forms of the microbe, its toxins or one of its surface proteins. The agent stimulates the body\'s immune system to recognize the agent as foreign, destroy it, and "remember" it, so that the immune system can more easily recognize and destroy any of these microorganisms that it later encounters (World Health Organization).'
    },
    Varicella: {
      title: 'Varicella (chickenpox)',
      definition:
        'Varicella, more commonly referred to as “chickenpox”, is an acute and highly contagious disease. It is caused by primary infection with the varicella-zoster virus (VZV). There is a vaccine for varicella (chickenpox) (World Health Organization).'
    },
    Vein: {
      title: 'Vein',
      definition: 'A blood vessel leading toward the heart.'
    },
    Ventilator: {
      title: 'Ventilator',
      definition: 'Mechanical breathing machine.'
    },
    Ventricle: {
      title: 'Ventricle',
      definition:
        'A small chamber, one of the central chambers in the brain, or one of the 2 lower chambers of the heart.'
    },
    VLBW: {
      title: 'Very Low Birth Weight (VLBW)',
      definition:
        'Very low birth weight babies weigh less than 1500 g or 3 lbs. 5 oz.'
    },
    'Very-Premature': {
      title: 'Very Premature',
      definition: 'Babies born between 28 and 32 weeks’ gestation.'
    },
    Viable: {
      title: 'Viable',
      definition: 'Viable means a newborn is potentially able to survive.'
    },
    'Vital-Signs': {
      title: 'Vital Signs',
      definition:
        'Temperature, heart rate, respiratory rate, and blood pressure.'
    },
    'Vitamin-D': {
      title: 'Vitamin D',
      definition:
        'Vitamin D can be received from sun exposure, food or supplements. Vitamin D promotes   calcium absorption in the gut. It is also needed for bone growth and bone remodeling. Without enough vitamin D, bones can become thin, brittle, or misshapen.'
    },
    Voiding: {
      title: 'Voiding',
      definition:
        'Emptying the bladder of urine. Also called urinating or peeing.'
    }
  },
  W: {},
  X: {
    'X-Ray': {
      title: 'X Ray',
      definition:
        'A form of electromagnetic radiation that can be used to take images of the human body, specifically bones.'
    }
  },
  Y: {
    Yeast: {
      title: 'Yeast',
      definition:
        'Is a fungal growth, which can be appear in the mouth, on the genitals or other parts of the body. It thrives in dark, moist environments.'
    }
  },
  Z: {
    'Zinc-Oxide': {
      title: 'Zinc Oxide',
      definition:
        'A barrier cream used to treat and prevent diaper rash. It is also used to treat cuts, scrapes and burns.'
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/en-CA-Glossary.js